import React from "react";
import GymNavigation from "../GymNavigation";
import Box from "components/UI/Box";
import moment from "moment";
import StarRating from "components/StarRating";

let reviews = r => {
  if (r) {
    if (r.length < 1) return <p>No Reviews</p>;
    else
      return r.map((currentItem, i, arr) => {
        const style = {
          header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          },
          headerRight: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flex: "5"
          },
          headerLeft: {
            display: "flex",
            flex: "7",
            justifyContent: "space-around",
            alignItems: "center"
          },
          reviewText: {
            textAlign: "left",
            fontSize: "18px",
            color: "#414141",
            marginLeft:'12px'
          },
          body: {
            paddingLeft: "15px"
          },
          customerName: {
            color: "#00b4d2",
            fontSize: "20px",
            margin: "0px"
          },
          deleteButton: {
            marginRight: "15px"
          },
          ratingWrapper: {
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline"
          },
          ratingText: {
            fontSize: "20px",
            color: "#444445",
            margin: "0px"
          },
          reviewDate: {
            fontSize: "20px",
            color: "#444445",
            margin: "0px"
          }
        };
        return (
          <div key={i}>
            <div style={style.header}>
              <div style={style.headerLeft}>
                <p style={style.customerName}>{currentItem.customer_name}</p>
                <div style={style.ratingWrapper}>
                  <p style={style.ratingText}>
                    {currentItem.rating
                      ? `${parseInt(currentItem.rating, 10)}.0`
                      : "0.0"}
                  </p>
                  <StarRating
                    readonly
                    initialRating={parseInt(currentItem.rating, 10)}
                  />
                </div>
                <p style={style.reviewDate}>
                  {moment(currentItem.date).format("YYYY MMM DD")}
                </p>
              </div>
              <div style={style.headerRight}>
                {/* <Button
            type="holo"
            style={{
              width: "67px",
              height: "28px",
              fontSize: "16px",
              color: "#444445",
              marginRight: "10px"
            }}
            holo
          >
            Reply
          </Button> */}
                {/* <p style={style.deleteButton}>Delete</p> */}
                <p style={style.deleteButton}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </p>
              </div>
            </div>

            <div style={style.body}>
              <p style={style.reviewText}>{currentItem.comment}</p>
            </div>
            {i !== arr.length - 1 ? (
              <hr
                style={{
                  borderTop: "1px solid #b5b5b6",
                  borderRadius: "0.5px"
                }}
              />
            ) : (
              ""
            )}
          </div>
        );
      });
  }
};

const Reviews = props => (
  <React.Fragment>
    <GymNavigation />
    <div style={style.wrapper}>
      <Box outline style={style.box}>
        {reviews(props.reviews)}
      </Box>
    </div>
  </React.Fragment>
);

export default Reviews;

const style = {
  box: {
    width: "900px",
    paddingTop: "50px"
  },
  wrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  }
};
